<spinner [isRunning]="showSpinner"></spinner>
<div class="main-container inputs-can-be-disabled">
  <div class="progress" style="position:fixed; width:100%; z-index:999; margin-top:0" *ngIf="autosave">
    <div class="indeterminate"></div>
  </div>
  <div class="row">
    <div class="col l12 s12 m12">
      <form *ngIf="isFormReady" novalidate [formGroup]="clearanceItemForm" (keydown.enter)="$event.target.tagName == 'TEXTAREA'">
        <div class="card">
          <div class="card-content">
            <div class="row ci-header-row">
              <div class="ci-header-title">{{ pageTitle }}</div>
              <div class="ci-header-actions">
                <a class="anchor" (click)="cancelClicked()">
                  <i class="material-icons" matTooltip="Close" matTooltipPosition="below">close</i>
                </a>
                <a *ngIf="!_authService.readOnly" class="anchor" [ngClass]="{ 'disabled': !(clearanceItemForm.valid && clearanceItemForm.dirty) }"
                  (click)='saveClearanceItem()'>
                  <i [ngClass]="{ 'disabled': !(clearanceItemForm.valid && clearanceItemForm.dirty) }" class="material-icons" matTooltip="Save" matTooltipPosition="below">save</i>
                </a>
                <a *ngIf="!_authService.readOnly" class="anchor " [ngClass]="{ 'disabled': !(clearanceItemForm.valid) }" (click)='copyItem()'>
                  <i [ngClass]="{ 'disabled': !(clearanceItemForm.valid) }" class="material-icons" matTooltip="Duplicate" matTooltipPosition="below">content_copy</i>
                </a>
                <a *ngIf="!_authService.readOnly" class="anchor" [ngClass]="{ 'disabled': !clearanceItemForm.valid }" (click)="createNew()">
                  <i [ngClass]="{ 'disabled': !clearanceItemForm.valid }" class="material-icons" matTooltip="Add New Item" matTooltipPosition="below">add</i>
                </a>
                <a *ngIf="clearanceItem.id" class="anchor hide-on-small-only" (click)="showHistory()">
                  <i class="material-icons" matTooltip="History" matTooltipPosition="below">history</i>
                </a>
                <a *ngIf='showDeleteBtn && !_authService.readOnly' class="anchor" [ngClass]="{'disabled' : !canItemBeDeleted() }" (click)='canItemBeDeleted() && deleteItem()'>
                  <i class="material-icons" [ngClass]="{'disabled' : !canItemBeDeleted() }" matTooltip="Delete" matTooltipPosition="below">delete</i>
                </a>
                <a *ngIf='clearanceItem.id' class="anchor" (click)='downloadAllAssets()'>
                  <i class="material-icons" [ngClass]="{'disabled' : !canItemBeDeleted() }" matTooltip="Download All" matTooltipPosition="below">file_download</i>
                </a>
                <a *ngIf="!isNewCI" class="anchor ci-chat-trigger" (click)="toggleNotesPanel()" matTooltip="Chat" matTooltipPosition="below">
                  <i class="material-icons">chat_bubble</i>
                  <span *ngIf="clearanceItem?.unreadNotesCount > 0" class="ci-chat-unread-badge">{{ clearanceItem?.unreadNotesCount }}</span>
                </a>
              </div>
            </div>
            <!-- The below is for mobile only -->
            <div class="row ci-summary-row">
              <div class="ci-summary-thumb animated flipInX" [ngClass]="{'list-thumbnail': !defaultImageUrl, 'primary-pic-thumbnail': defaultImageUrl}">
                <i *ngIf="!defaultImageUrl" class="material-icons">image</i>
                <img *ngIf="defaultImageUrl" [src]="defaultImageUrl" alt="">
              </div>
              <div class="ci-summary-titles">
                <div class="aka-title-item-row aka-title-item-row--main">
                  <div class="aka-title-radio-spacer" aria-hidden="true"></div>
                  <div class="aka-title-input">
                    <mat-form-field appearance="fill" class="aka-title-field main-title-field">
                      <input #itemNameInput matInput class="nowrapping" id="itemName" tabindex="1" type="text" name="itemName" formControlName="name"
                        maxlength="80" (input)="onCINameChanged($event.target.value)">
                      <mat-label><span class="mandatory">* </span>Item Title</mat-label>
                    </mat-form-field>
                    <div class="mandatory" [hidden]="!displayMessage.name">{{displayMessage.name}}</div>
                  </div>
                  <div class="aka-title-actions">
                    <a *ngIf="!_authService.readOnly" class="anchor title-action-icon" (click)="addTtitle(-1)" matTooltip="add title" matTooltipPosition="below">
                      <i class="material-icons">add</i>
                    </a>
                    <span class="aka-title-action-spacer" aria-hidden="true"></span>
                  </div>
                </div>
                <div formArrayName="titles">
                  <ng-container *ngFor="let item of titles.controls; let i=index">
                  <div [formGroup]="item" class="aka-title-item-row" *ngIf="item && item.get('isDefault') && !item.get('isDefault').value">
                    <div class="aka-radio-col" matTooltip="Set as default title" matTooltipPosition="below">
                      <input class="ci-title-radio-input" type="radio" id="{{ 'defaultTitle' + i }}" name="defaultTitle"
                        [value]="item.get('id')?.value" formControlName="defaultTitle"
                        [checked]="defaultTitle == item.get('id')?.value"
                        [attr.disabled]="_authService.readOnly ? '' : null" />
                      <label attr.for="{{ 'defaultTitle' + i }}"></label>
                    </div>
                    <div class="aka-title-input">
                      <mat-form-field appearance="fill" class="aka-title-field">
                        <input matInput id="{{ 'itemName' + i}}" class="nowrapping" tabindex="1" type="text" name="itemName"
                          maxlength="80" formControlName="name">
                      </mat-form-field>
                    </div>
                    <div class="aka-title-actions">
                      <a *ngIf="!_authService.readOnly" class="anchor title-action-icon" (click)="addTtitle(-1)" matTooltip="add title" matTooltipPosition="below">
                        <i class="material-icons">add</i>
                      </a>
                      <a *ngIf="!_authService.readOnly" class="anchor title-action-icon" (click)="addTtitle(i)" matTooltip="remove title" matTooltipPosition="below">
                        <i class="material-icons">remove</i>
                      </a>
                    </div>
                  </div>
                  </ng-container>
                </div>
              </div>
              <div class="ci-summary-meta">
                <div class="ci-summary-status">
                  <mat-form-field appearance="fill" class="ci-status-field">
                    <mat-label>Status</mat-label>
                    <mat-select tabindex="2" id="statusSelect" formControlName="status">
                      <mat-option *ngFor="let stat of visibleStatusLookup" [value]="stat.name">{{stat.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="ci-summary-toggle">
                  <span class="ci-prod-toggle-label">Created by production</span>
                  <div class="ci-prod-toggle-control">
                    <span class="ci-prod-toggle-side">No</span>
                    <mat-slide-toggle class="ci-prod-toggle-switch" color="accent" name="isCreatedByProd" tabindex="3"
                      formControlName="isCreatedByProd" [disabled]="_authService.readOnly"
                      aria-label="Created by production"></mat-slide-toggle>
                    <span class="ci-prod-toggle-side">Yes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="divider hide-on-large-only"></div>
            <div class="ci-form-row ci-form-row--full">
              <mat-form-field appearance="fill" class="ci-form-field">
                <textarea matInput id="description" autoGrow tabindex="4" name="descriptions"
                  formControlName="description"></textarea>
                <mat-label>Description of Use</mat-label>
              </mat-form-field>
            </div>
            <div class="divider hide-on-large-only"></div>
            <div class="ci-form-row ci-form-row--thirds">
              <mat-form-field appearance="fill" class="ci-form-field">
                <input matInput id="copyright" tabindex="5" name="copyright" formControlName="copyrightInfo" type="text">
                <mat-label>Copyright/Owner</mat-label>
              </mat-form-field>
              <mat-form-field appearance="fill" class="ci-form-field">
                <input matInput id="artistAuthorName" tabindex="6" name="artistAuthorName1" formControlName="artistAuthorName"
                  type="text">
                <mat-label>Artist/Author Name</mat-label>
              </mat-form-field>
              <mat-form-field appearance="fill" class="ci-form-field">
                <mat-label>Deadline</mat-label>
                <input matInput [matDatepicker]="deadlinePicker" id="deadline" name="deadline" formControlName="deadline">
                <mat-datepicker-toggle matSuffix [for]="deadlinePicker"></mat-datepicker-toggle>
                <mat-datepicker #deadlinePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <ng-container *ngIf="isClearanceUser">
              <div class="ci-form-row ci-form-row--halves">
                <mat-form-field appearance="fill" class="ci-form-field">
                  <mat-label>Report Group Name</mat-label>
                  <input matInput tabindex="7" id="reportGroupName" name="reportGroupName" formControlName="reportGroupName"
                    [matAutocomplete]="reportGroupAuto" type="text">
                  <mat-autocomplete #reportGroupAuto="matAutocomplete" (optionSelected)="onReportGroupSelected($event.option.value)">
                    <mat-option *ngFor="let rg of filteredReportGroups" [value]="rg">{{ rg }}</mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="fill" class="ci-form-field">
                  <input matInput id="scene" tabindex="8" type="text" name="scene" formControlName="scene">
                  <mat-label>Scene/Set</mat-label>
                </mat-form-field>
              </div>
              <div class="ci-form-row ci-form-row--halves">
                <mat-form-field appearance="fill" class="ci-form-field">
                  <input matInput id="season" tabindex="9" type="text" name="season" formControlName="season">
                  <mat-label>Season</mat-label>
                </mat-form-field>
                <div class="ci-form-field-wrap">
                  <mat-form-field appearance="fill" class="ci-form-field">
                    <input matInput id="episode" tabindex="10" type="text" name="episode" formControlName="episode">
                    <mat-label><span class="mandatory" *ngIf="projectDepartment == 'TV'">* </span>Episode</mat-label>
                  </mat-form-field>
                  <div class="mandatory" [hidden]="!displayMessage.episode" *ngIf="projectDepartment == 'TV'">{{displayMessage.episode}}</div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isClearanceUser">
              <div class="ci-form-row ci-form-row--thirds">
                <mat-form-field appearance="fill" class="ci-form-field">
                  <input matInput id="scene" tabindex="8" type="text" name="scene" formControlName="scene">
                  <mat-label>Scene/Set</mat-label>
                </mat-form-field>
                <mat-form-field appearance="fill" class="ci-form-field">
                  <input matInput id="season" tabindex="9" type="text" name="season" formControlName="season">
                  <mat-label>Season</mat-label>
                </mat-form-field>
                <div class="ci-form-field-wrap">
                  <mat-form-field appearance="fill" class="ci-form-field">
                    <input matInput id="episode" tabindex="10" type="text" name="episode" formControlName="episode">
                    <mat-label><span class="mandatory" *ngIf="projectDepartment == 'TV'">* </span>Episode</mat-label>
                  </mat-form-field>
                  <div class="mandatory" [hidden]="!displayMessage.episode" *ngIf="projectDepartment == 'TV'">{{displayMessage.episode}}</div>
                </div>
              </div>
            </ng-container>
            <div class="ci-form-row ci-form-row--full">
              <div class="ci-form-field-wrap">
                <link-text-area [value]="clearanceItemForm.controls.refUrl.value" [labelText]="'Reference URL'"
                  (changedTextEvent)="refURLChanged($event)"></link-text-area>
              </div>
            </div>
            <div class="divider hide-on-large-only"></div>
            <div class="row">
              <div class="col l12 s12">
                <clearanceItem-tag #tagComponent [clearanceItemForm]="clearanceItemForm" [globalTags]="globalTags" [preLoadTags]="false"
                  [isClearanceUser]="isClearanceUser" [canTagsBeToggled]="enableTags()"
                  [projectId]="projectId" (newTagAdded)="newTagAdded($event)" (globalTagAdded)="globalTagAdded($event)"  (customTagDeleted)="deleteCustomTagFromUI($event)" ></clearanceItem-tag>
                <div class="mandatory center" [hidden]="!displayMessage.selectedTags">{{displayMessage.selectedTags}}</div>
              </div>
              <!-- {{ clearanceItemForm.controls.selectedTags.value | json}} -->
            </div>
            <div class="divider hide-on-large-only"></div>
            <div class="row images-upload">
                <div class="ci-images-upload-col col l4 s12">
                  <clearance-asset-manager #imageAsset formArrayName="images" assetType="image" asset="Image"
                    assetLabel="Add a Clearance Item Image" [projectId]="projectId" [group]="clearanceItemForm"
                    [assetsArray]="clearanceItemForm.controls.images" [assetsArrayName]="images" [ownerType]="'ci'"
                    (defaultAssetChanged)="defaultImageChanged($event)" (itemDeleted)="onItemDeleted($event)"
                    [isClearanceUser]="isClearanceUser" [showOpenInNew]="false" [readOnly]="_authService.readOnly"
                    [projectDepartment]="projectDepartment" [itemStatus]="clearanceItem.status" [statusComments]="clearanceItem.statusChangeComments"
                    [currentCI]="clearanceItem" (onCIStatusChanged)="ciStatusChange($event)">
                  </clearance-asset-manager>
                </div>
                <div class="ci-images-upload-col col l4 s12">
                  <clearance-asset-manager #imageRefAsset formArrayName="imagesRef" assetType="image" asset="Reference"
                    assetLabel="Add a Reference/Stock Image" [projectId]="projectId" [group]="clearanceItemForm"
                    [hideReportDefaultIcons]="true" [assetsArray]="clearanceItemForm.controls.imagesRef"
                    [assetsArrayName]="imagesRef" [ownerType]="'ci'" (itemDeleted)="onItemDeleted($event)"
                    [isClearanceUser]="isClearanceUser" [showOpenInNew]="false" [readOnly]="_authService.readOnly"
                    [projectDepartment]="projectDepartment" [itemStatus]="clearanceItem.status" [statusComments]="clearanceItem.statusChangeComments"
                    [currentCI]="clearanceItem">
                  </clearance-asset-manager>
                </div>
                <div class="ci-images-upload-col col l4 s12">
                  <clearance-asset-manager #documentAsset formArrayName="documents" assetType="document" asset="Document"
                    assetLabel="Add a Release Form" [projectId]="projectId" [group]="clearanceItemForm" [assetsArray]="clearanceItemForm.controls.documents"
                    [assetsArrayName]="documents" [ownerType]="'ci'" (itemDeleted)="onItemDeleted($event)"
                    [isClearanceUser]="isClearanceUser" [showOpenInNew]="false" [readOnly]="_authService.readOnly">
                  </clearance-asset-manager>
                </div>
            </div>
            <div class="divider hide-on-large-only"></div>
            <div class="row">
              <div class="col l12 s12" formArrayName="restrictions">
                <div *ngFor="let rest of clearanceItemForm.controls.restrictions.controls; let i=index">
                  <div [formGroupName]="i">
                    <div class="input-field col l12 s12 restriction-row" *ngIf="showRestriction(rest.controls.restrictionType.value)">
                      <mat-form-field appearance="fill" class="restriction-field">
                        <mat-label>
                          <mat-icon *ngIf="rest.controls.restrictionType.value === 'Ad/Pub'"
                            class="pin-icon restriction-pin-icon"
                            [class.pinned-restriction]="rest.controls.pinned.value"
                            (click)="toggleRestrictionPin($event, rest)">push_pin</mat-icon>{{  rest.controls.restrictionType.value == 'Notes' || rest.controls.restrictionType.value == 'Notes S&P' ? 'Report ' + rest.controls.restrictionType.value + ' description' : rest.controls.restrictionType.value + ' description' }}
                        </mat-label>
                        <textarea matInput autoGrow tabindex="1" id="{{ 'restdesc' + i }}" name="{{'descName'+i}}" formControlName="description" [readonly]="!isClearanceUser"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 
          <div class="card-action ci-footer-actions">
            <button mat-button type="button" tabindex="15" class="negative ci-footer-btn" (click)="cancelClicked()">Cancel</button>
            <button mat-button *ngIf="!_authService.readOnly" type="button" tabindex="16" class="affermative ci-footer-btn" (click)='saveClearanceItem()' [disabled]="!(clearanceItemForm.valid && clearanceItemForm.dirty)">Save</button>
            <button mat-button *ngIf="!_authService.readOnly" type="button" tabindex="17" class="affermative ci-footer-btn" (click)='saveClearanceItem(false,true)' [disabled]="!(clearanceItemForm.valid && clearanceItemForm.dirty)">Save & Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>
<div class="other-titles-overlay" *ngIf="showStatusChangeModal" (click)="cancelStatusChange()">
  <form novalidate #statusChangeForm="ngForm" class="other-titles-modal modal-status status-change-modal" (click)="stopPropagation($event)">
    <div class="status-change-modal-body">
      <h4>Change Status</h4>
      <mat-form-field appearance="fill" class="status-change-comments-field">
        <mat-label>Comments</mat-label>
        <textarea matInput id="comments" name="comments" [(ngModel)]="statusChangeComments"></textarea>
      </mat-form-field>
    </div>
    <div class="status-change-modal-footer modal-footer-two-lines">
      <button mat-button class="btn-flat" type="button" (click)="changeStatusWithoutComments()"
        *ngIf="clearanceItemForm.controls['status'] && (clearanceItemForm.controls['status'].value=='PENDING - Production Info Required' || clearanceItemForm.controls['status'].value=='PENDING - Modifications Required')">Change without comments</button>
      <br class="dividing-line-hidden">
      <button mat-button class="btn-flat" type="button" (click)="changeStatusComments()">Change</button>
      <button mat-button class="btn-flat" type="button" (click)="cancelStatusChange()">Cancel</button>
    </div>
  </form>
</div>

<notes-panel #notesPanel *ngIf="!isNewCI" [clearanceItemId]="clearanceItem?.id" [unreadNotesCount]="clearanceItem?.unreadNotesCount" (notesRead)="onNotesRead()"></notes-panel>
<!--Create New Asset Button-->
<!-- <div class="fixed-action-btn" [ngClass]="{ 'disabled': !clearanceItemForm.valid }">
  <a (click)="createNew()" class="btn-floating btn-large waves-effect waves-light hoverable" [ngClass]="{ 'disabled': !clearanceItemForm.valid }"
    matTooltip="new item" matTooltipPosition="above">
    <i class="material-icons">add</i>
  </a>
</div> -->
<!-- clearanceItemForm.controls.titles.value: {{ clearanceItemForm.controls.titles.value | json }} -->
<!-- {{ clearanceItemForm.value | json}} -->
<!-- clearanceItemForm.dirty: {{clearanceItemForm.dirty }}<br>
clearanceItemForm.valid: {{clearanceItemForm.valid }}<br> -->
<!-- displayMessage: {{displayMessage | json }} -->
